import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { page }  from '../class/status';

/*@types/jquery 沒有 bootstrap 的 .modal()，跟 gm.component.ts 一樣用 any 繞過*/
declare var $:any;

@Component({
  selector: 'app-manualtitle',
  templateUrl: './manualtitle.component.html',
  styleUrls: ['./manualtitle.component.css']
})
export class ManualtitleComponent implements OnInit {

  constructor(
    public httpClient: HttpClient,
  ) { }

  loading:boolean = true;
  data:any = [];
  rank_list:any = [];
  lv_option_list:any = [];

  /*keyword 可填 uid 或電話；is_manual 是來源篩選(-1 全部 / 1 手動 / 0 排程)*/
  search:any = {keyword:'',user_rank_id:-1,status:-1,is_manual:-1};
  give_data:any = {keyword:'',user_rank_id:-1,user_rank_lv_id:-1,remark:''};

  /*searched 是「這次結果對應的查詢條件」的快照。
    直接讀 search 的話，使用者查完又去改輸入框，下面的說明文字會跟著跳動、對不上畫面上的結果。*/
  searched:any = {keyword:'',user_rank_id:-1,status:-1,is_manual:-1};
  /*查無資料時後端回的關鍵字對應用戶（最多 2 筆）*/
  search_user:any = [];

  /*活動等級編輯：edit_rank 是正在編輯的活動，edit_lv_list 是等級草稿*/
  edit_rank:any = null;
  edit_lv_list:any = [];

  pageobj:page = {page:0,count:30,total_count:0};
  pageobjstr:string = JSON.parse(JSON.stringify(this.pageobj));

  status_list:any = [
    {id:1,name:'生效中'},
    {id:0,name:'已到期'},
    {id:2,name:'已被取代'},
    {id:3,name:'已收回'},
  ];

  source_list:any = [
    {id:1,name:'手動給予'},
    {id:0,name:'排程自動'},
  ];

  /*頁籤。rank_list 與稱號紀錄都由同一支 init_list() 一次撈回來，
    所以切換頁籤純粹是顯示切換，不用重新請求。*/
  tab:string = 'rank';
  menu_list:any = [
    {id:'rank',name:'活動清單'},
    {id:'record',name:'稱號紀錄'},
  ];

  ngOnInit(): void {
    this.init_list();
  }

  status_name(v:any){
    const hit = this.status_list.find((o:any)=> o.id == v);
    return hit ? hit.name : v;
  }

  source_name(v:any){
    return (v*1 == 1) ? '手動給予' : '排程自動';
  }

  /*查無資料時的說明。只寫「無資料」的話，操作員分不清是打錯電話、
    被篩選條件擋掉、還是這個人真的沒有稱號。*/
  empty_msg(){
    const has_filter = (this.searched.user_rank_id != -1
      || this.searched.status != -1
      || this.searched.is_manual != -1);

    if(this.searched.keyword.length == 0){
      return has_filter
        ? '目前的篩選條件下沒有稱號紀錄，把來源、稱號與狀態都改成「全部」可以看到全部紀錄。'
        : '目前系統裡沒有任何稱號紀錄。';
    }

    if(this.search_user.length == 0){
      return `查不到 uid 或電話為「${this.searched.keyword}」的用戶。uid 需完全相符，電話可只填一段。`;
    }

    if(this.search_user.length > 1){
      return `「${this.searched.keyword}」對應到多位用戶，其中沒有符合目前條件的稱號紀錄。`;
    }

    const u = this.search_user[0];
    const owned = u.rank_count * 1;

    /*rank_count 不套用篩選條件，所以這裡有數字就一定是被篩選擋掉，不能說他沒有稱號*/
    if(owned > 0){
      return `${u.uid}（${u.name}）有 ${owned} 筆稱號紀錄，但都不符合目前的來源／稱號／狀態篩選條件。`;
    }

    return `${u.uid}（${u.name}）目前完全沒有任何稱號紀錄，排程給的也沒有。`;
  }

  init_give_data(){
    this.give_data = {keyword:'',user_rank_id:-1,user_rank_lv_id:-1,remark:''};
    this.lv_option_list = [];
  }

  /*選了稱號才帶出底下的等級。
    rank_list 的 detail 現在含 real_info=0 的說明列（等級編輯要用），
    但給予只能選真實等級，所以這裡要濾掉 —— 後端也會擋，這裡是不讓人選錯。*/
  ck_lv_list(){
    this.give_data.user_rank_lv_id = -1;
    const hit = this.rank_list.find((o:any)=> o.id == this.give_data.user_rank_id);
    this.lv_option_list = hit ? (hit.detail || []).filter((d:any)=> d.real_info == 1) : [];
  }

  gender_name(v:any){
    return (v*1 == 1) ? '男' : '女';
  }

  /*該活動底下有多少用戶紀錄 —— 用來提醒操作員這個活動已經在用了*/
  rank_used(item:any){
    let n = 0;
    for(const d of (item.detail || [])){ n += d.used_count * 1; }
    return n;
  }

  /*開啟等級編輯。深拷貝一份草稿，改到一半按取消不會污染畫面上的清單*/
  open_lv_edit(item:any){
    this.edit_rank = {id:item.id, name:item.name};
    this.edit_lv_list = JSON.parse(JSON.stringify(item.detail || []));
  }

  add_lv(){
    this.edit_lv_list.push({id:-1,name:'',threshold:0,once_reward:0,real_info:1,frame:'',used_count:0});
  }

  del_lv(i:number){
    /*已被用戶紀錄引用的等級不能刪，刪了那些紀錄會變孤兒。後端也會擋一次*/
    if(this.edit_lv_list[i].used_count * 1 > 0){
      alert('這個等級已有用戶紀錄，不可刪除。');
      return;
    }
    this.edit_lv_list.splice(i,1);
  }

  save_lv(){
    if(!this.edit_rank){ return; }

    for(const d of this.edit_lv_list){
      if(String(d.name).trim().length == 0){
        alert('等級名稱不可空白');
        return;
      }
    }
    if(this.edit_lv_list.filter((d:any)=> d.real_info == 1).length == 0){
      alert('至少要有一個真實等級（是否計算=是）');
      return;
    }

    this.loading = true;
    const body = {user_rank_id:this.edit_rank.id, detail:this.edit_lv_list};
    this.httpClient.post<any>("/update_user_rank_lv.php",body).subscribe(res => {
      this.loading = false;
      alert(res.message);
      if(res.status){
        /*只有成功才關 modal。失敗時留著草稿，操作員不用重打一遍。
          成功後一定要重新撈 rank_list —— 新增的等級要換回真正的 id，
          不然同一份草稿再存一次會變成重複新增。*/
        try { $('.bd-lv-edit-modal').modal('hide'); } catch(e){}
        this.edit_rank = null;
        this.edit_lv_list = [];
        this.init_list();
      }
    });
  }

  do_search(){
    this.pageobj.page = 0;
    this.init_list();
  }

  init_list(){
    this.loading = true;
    const body = {
      page: this.pageobj.page,
      count: this.pageobj.count,
      keyword: this.search.keyword,
      user_rank_id: this.search.user_rank_id,
      status: this.search.status,
      is_manual: this.search.is_manual,
    };
    const sent = JSON.parse(JSON.stringify(this.search));
    this.httpClient.post<any>("/get_manual_user_rank.php",body).subscribe(res => {
      this.loading = false;
      this.searched = sent;
      this.rank_list = res.rank_list || [];
      this.search_user = res.search_user || [];
      if(res.status){
        this.data = res.data;
        this.pageobj.total_count = res.total_count;
      }else{
        this.data = [];
        this.pageobj.total_count = 0;
      }
      this.pageobjstr = JSON.parse(JSON.stringify(this.pageobj));
    });
  }

  give(){
    if(this.give_data.keyword.length == 0){
      alert('請填寫用戶 uid 或電話');
      return;
    }
    if(this.give_data.user_rank_lv_id * 1 <= 0){
      alert('請選擇稱號等級');
      return;
    }

    this.loading = true;
    const body = {
      action: 'give',
      keyword: this.give_data.keyword,
      user_rank_lv_id: this.give_data.user_rank_lv_id,
      remark: this.give_data.remark,
    };
    this.httpClient.post<any>("/update_manual_user_rank.php",body).subscribe(res => {
      this.loading = false;
      alert(res.message);
      if(res.status){
        this.init_give_data();
        this.init_list();
      }
    });
  }

  cancel(item:any){
    if(!confirm(`確定收回 ${item.uid} 的「${item.lv_name}」？收回後排程會依實際消費重新計算。`)){
      return;
    }

    this.loading = true;
    const body = {action:'cancel',id:item.id};
    this.httpClient.post<any>("/update_manual_user_rank.php",body).subscribe(res => {
      this.loading = false;
      alert(res.message);
      if(res.status) this.init_list();
    });
  }

  callback(pageobj:page){
    if(JSON.stringify(this.pageobj) != JSON.stringify(pageobj)){
      this.pageobj = pageobj;
      this.init_list();
    }
  }

}
